// AI-assisted: Claude 2026-08-07, human-reviewed: ausstehend
export function toast(msg: string): void {
  window.dispatchEvent(new CustomEvent("fithub:toast", { detail: { msg } }))
}
